import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
import { HypothesisSummaryCard } from './_hypothesis-card';
import { ExposuresSummaryCard } from './_exposures-card';
import { ExperimentPageSummaryMetrics } from './_metrics';
import { ExperimentPageBanner } from './_banner';
export function ExperimentPageSummary() {
  const {
    t
  } = useTranslation();
  return <div className={styles.summary} data-sentry-component="ExperimentPageSummary" data-sentry-source-file="index.tsx">
      <div className={styles.subheader}>{t("experiments.main.summary.status")}</div>
      <ExperimentPageBanner data-sentry-element="ExperimentPageBanner" data-sentry-source-file="index.tsx" />
      <div className={styles.subheader}>{t("experiments.main.summary.overview")}</div>
      <div className={styles.summaryCards}>
        <HypothesisSummaryCard className={styles.summaryCard} data-sentry-element="HypothesisSummaryCard" data-sentry-source-file="index.tsx" />
        <ExposuresSummaryCard className={styles.summaryCard} data-sentry-element="ExposuresSummaryCard" data-sentry-source-file="index.tsx" />
      </div>
      <div className={clsx(styles.subheader, styles.noGap)}>{t("experiments.main.summary.results")}</div>
      <ExperimentPageSummaryMetrics data-sentry-element="ExperimentPageSummaryMetrics" data-sentry-source-file="index.tsx" />
    </div>;
}